/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WorkflowModelEntity } from './WorkflowModelEntity';
import {
    WorkflowModelEntityFromJSON,
    WorkflowModelEntityFromJSONTyped,
    WorkflowModelEntityToJSON,
    WorkflowModelEntityToJSONTyped,
} from './WorkflowModelEntity';
import type { NodeActionsEntity } from './NodeActionsEntity';
import {
    NodeActionsEntityFromJSON,
    NodeActionsEntityFromJSONTyped,
    NodeActionsEntityToJSON,
    NodeActionsEntityToJSONTyped,
} from './NodeActionsEntity';

/**
 * 
 * @export
 * @interface ModelWithNodeActionsEntity
 */
export interface ModelWithNodeActionsEntity {
    /**
     * ワークフローモデル
     * @type {WorkflowModelEntity}
     * @memberof ModelWithNodeActionsEntity
     */
    model: WorkflowModelEntity;
    /**
     * 権限を持っているノードと権限を持っているアクションの組み合わせ
     * @type {Array<NodeActionsEntity>}
     * @memberof ModelWithNodeActionsEntity
     */
    nodeActions: Array<NodeActionsEntity>;
}

/**
 * Check if a given object implements the ModelWithNodeActionsEntity interface.
 */
export function instanceOfModelWithNodeActionsEntity(value: object): value is ModelWithNodeActionsEntity {
    if (!('model' in value) || value['model'] === undefined) return false;
    if (!('nodeActions' in value) || value['nodeActions'] === undefined) return false;
    return true;
}

export function ModelWithNodeActionsEntityFromJSON(json: any): ModelWithNodeActionsEntity {
    return ModelWithNodeActionsEntityFromJSONTyped(json, false);
}

export function ModelWithNodeActionsEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): ModelWithNodeActionsEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'model': WorkflowModelEntityFromJSON(json['model']),
        'nodeActions': ((json['nodeActions'] as Array<any>).map(NodeActionsEntityFromJSON)),
    };
}

export function ModelWithNodeActionsEntityToJSON(json: any): ModelWithNodeActionsEntity {
    return ModelWithNodeActionsEntityToJSONTyped(json, false);
}

export function ModelWithNodeActionsEntityToJSONTyped(value?: ModelWithNodeActionsEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'model': WorkflowModelEntityToJSON(value['model']),
        'nodeActions': ((value['nodeActions'] as Array<any>).map(NodeActionsEntityToJSON)),
    };
}

